module.exports = __webpack_public_path__ + "img/recently-added.ab9618d0.svg";